import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './core/services/auth.service';
import { IconService } from './core/services/icon.service';
import { LocalStorageService } from './core/services/localstorage.service';
import { SnackBarService } from './core/services/snack-bar.service';
import { userActions } from './core/store/userData/userData.actions';

@Component({
  selector: 'aoe-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {

  isInitialized = false;


  constructor(
    private readonly iconService: IconService,
    private readonly store: Store,
    private readonly localStorageService: LocalStorageService,
    private readonly authService: AuthService,
    private readonly snackbarService: SnackBarService
  ) {
    this.iconService.registerIcons();
    const localdata = this.localStorageService.getLocalStorage();
    if (localdata?.t) {
      this.authService.getTokenData().pipe(
        tap((res) => {
          if (res.data)
            this.store.dispatch(userActions['[User]-AddUser'](res.data));
          // this.store.dispatch(eventActions['loadEvent']({ payload: { visible: true } }));
        })
      ).subscribe({
        next: () => {
          this.isInitialized = true;
        },
        error: (err) => {
          if (err.status === 498 || err.status === 403) {
            this.localStorageService.removeElement('t');
            this.snackbarService.openErrorSnackBar('Vous avez été déconnecté');
            authService.getToken({ clientId: environment.clientId, clientSecret: environment.clientSecret, code: null, grant_type: 'client_credentials' }).pipe(
              tap(res => localStorageService.addData({ 't': res.data.accessToken })
              )).subscribe({
                next: (res) => {
                  this.store.dispatch(userActions['[User]-AddUser'](res.data));
                },
                error: () => { }
              })
          }
          this.isInitialized = true;
        },
      })
    } else {
      this.isInitialized = true;
    }
  }

}
